import { Type } from "class-transformer";
import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";
import addYears from "date-fns/addYears";

export const FullNameValidationRules: EntityValidationRules<Person> = {
  fullName: {
    required: true,
    prohibitedCharacters: true,
    isLength: {
      max: 45,
    },
  },
};

export const BirthDateValidationRules: EntityValidationRules<Person> = {
  birthDate: {
    requiredIf: {
      condition: (entity: Person) => entity._validateBirthDate === true,
    },
    dateRange: {
      min: addYears(new Date(), -130),
      max: addYears(new Date(), -18),
    },
  },
};

export const AddressValidationRules: EntityValidationRules<Person> = {
  mailingAddress: {
    required: true,
    prohibitedCharacters: true,
    isLength: {
      max: 75,
    },
  },
};

export const EmailAddressValidationRules: EntityValidationRules<Person> = {
  emailAddress: {
    isEmail: {
      required: false,
    },
    isLength: {
      max: 254,
    },
  },
};

export const PhoneNumberValidationRules: EntityValidationRules<Person> = {
  phoneNumber: {
    isPhoneNumber: {
      required: false,
    },
  },
};

export default class Person {
  @observable
  fullName?: string;

  @Type(() => Date)
  @observable
  birthDate?: Date;

  @observable
  _validateBirthDate = true;

  @observable
  mailingAddress?: string;

  @observable
  emailAddress?: string;

  @observable
  phoneNumber?: string;

  @computed
  get rules(): EntityValidationRules<Person> {
    return {
      ...FullNameValidationRules,
      ...BirthDateValidationRules,
      ...AddressValidationRules,
      ...EmailAddressValidationRules,
      ...PhoneNumberValidationRules,
    };
  }
}
